import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { Layout } from 'antd'
import _ from 'lodash'
import { ThemeProvider } from 'styled-components'
import AlertContainer from '../Notifications/AlertContainer'
import AppHolder from './commonStyle'
import themeDefault from '../../../config/theme/themedefault'

import { siteConfig } from '../../../config/index'

import appActions from '../../redux/app/actions'
import authActions from '../../redux/auth/actions'

const { toggleAll } = appActions
const { getToken } = authActions
const { Content, Footer } = Layout

class Header extends Component {
    componentDidMount () {
        this.props.getToken()
        this.handleResize = _.debounce(() => {
            this.props.toggleAll(window.innerWidth, window.innerHeight)
        }, 90)
        this.props.toggleAll(window.innerWidth, window.innerHeight)
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.handleResize)
        if (this.handleResize && this.handleResize.cancel) this.handleResize.cancel()
    }

    render () {
        const { App, children } = this.props

        if (App.get('height') === 0) {
            return <div />
        }

        return (
            <header>
                <ThemeProvider theme={themeDefault}>
                    <AppHolder>
                        <Layout style={{ height: '100vh', marginTop: 40 }}>
                            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
                                <AlertContainer />
                                <Layout className="" style={{ height: '100vh' }}>
                                    <Content
                                        style={{
                                            flexShrink: '0',
                                            background: '#f1f3f6',
                                            width: '100%'
                                        }}
                                    >
                                        {children}
                                    </Content>
                                </Layout>
                            </Layout>
                        </Layout>
                    </AppHolder>
                </ThemeProvider>
            </header>
        )
    }
}

const mapStateToProps = state => ({
    App: state.get('App')
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getToken,
        toggleAll
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
